import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/login/index.vue'
import EipManage from '@/views/appEntry/EipManage.vue'
import WuJieTemp from '@/views/appEntry/WuJieTemp.vue'
import store from '@/store'
import { getUrlKey } from '@/utils/common'

const basename = '/base/'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/layouts',
    name: 'layouts',
    component: () => import('@/views/layouts/index'),
    children: [
      {
        path: '/eipManage/*',
        name: 'EipManage',
        component: EipManage
      },
      {
        path: '/wuJieTemp/*',
        name: 'WuJieTemp',
        component: WuJieTemp
      },
      {
        path: '/home',
        name: 'home',
        component: Home
      }
    ]
  },
  {
    path: '/login/:tenantCode',
    name: 'login',
    component: Login,
    meta: {
      single: true,
      unLogin: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      single: true,
      unLogin: true
    }
  }
]

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置

const router = new VueRouter({
  mode: 'history',
  base: basename,
  routes
})

// 路由钩子，全局前置守卫
router.beforeEach(async (to, from, next) => {
  try {
    const params = getUrlKey(to.fullPath)
    const ticket = params.ticket || params.unified_token
    
    // 获取系统登入登出配置
    if (!store.state.sys.ssoConfig) {
      await store.dispatch('sys/getSsoConfig')
    }
    if (to.name === 'login') {
      next()
      return
    }
    // token 校验
    if (!store.state.sys.token) {
      // 金智认证
      if (store.state.sys.ssoConfig.mode === 'jzcas') {
        await store.dispatch('sys/jzAuthenticate')
      } else {
        // 默认cas认证
        await store.dispatch('sys/authenticate', ticket)
      }
    }
    if (ticket) {
      if(store.state.sys.ssoConfig.mode === 'kyoauth') {
        next(to.fullPath.split(/[&,?]unified_token=/)[0])
      } else {
        next(to.fullPath.split(/[&,?]ticket=/)[0])
      }
      return
    }
    // 是否已获取当前登录用户
    if (store.state.sys.token && !store.state.sys.currentUser) {
      await store.dispatch('sys/getCurrentUserInfo')
    }
    // 用户已登录且未获取用户详情，调用用户详情接口
    if (store.state.sys.token && !store.state.sys.currentUserDetail) {
      await store.dispatch('sys/getCurrentUserDetail')
    }
    // 设置租户code
    if (to.name === 'login' && to.params.tenantCode) {
      store.commit('sys/setTenantCode', to.params.tenantCode)
    }
    if (store.state.sys.token && (store.state.sys.isFirstLoad || to.name === 'login')) {
      await store.dispatch('sys/getTenant', store.state.sys.tenantCode)
    }
    if (store.state.sys.token && !to.meta.unLogin && store.state.menu.menuList.length === 0) {
      // 需要登录
      await store.dispatch('menu/getMenuList', to)
    }
    // 结束第一次加载
    if (store.state.sys.isFirstLoad) {
      store.commit('sys/setIsFirstLoad', false)
    }
  } catch (e) {
    console.error(e)
    store.commit('error/setError', {
      flag: true,
      msg: '系统异常'
    })
  }
  next()
})

export default router
